import i18n from '@/helper/i18n';

export const formatCreditorVoucherType = (value) => {
  return i18n.te(`masterData.creditorVouchers.creditorVoucherTypes.${value}`)
    ? i18n.t(`masterData.creditorVouchers.creditorVoucherTypes.${value}`)
    : value;
};

export default formatCreditorVoucherType;
